import React from 'react';
import { ScaleIcon } from 'lucide-react';
import { licensing, principles } from '../data/profile';
import { SectionHeading } from './SectionHeading';
export function Philosophy() {
  return <section id="filosofia" className="border-b border-hairline py-24 lg:py-32" data-id="element-148" data-mp="307253oosf31q">
      <div className="mx-auto max-w-6xl px-6" data-id="element-149" data-mp="355n6vsjotusa">
        <SectionHeading index="03 — Filosofía" title="Reglas que no negocio" description="No son eslóganes: son las decisiones que se repiten en cada repo, desde el firmware de un ESP32 hasta el sitio que documenta todo lo demás." data-id="element-150" data-mp="354c2bqif4j04" />

        <div className="mt-14 grid gap-x-12 gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-151" data-mp="2h87oea5rjsix">
          {principles.map((p, i) => <article key={p.title} className="border-t border-hairline pt-5" data-id="element-152" data-mp="2m7kagsot8vkg" data-mpi={i}>
              <span className="font-mono text-xs text-ink-mid" data-id="element-153" data-mp="fg1n9e2gqdiz">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-3 font-mono text-lg font-medium text-ink-hi" data-id="element-154" data-mp="kew6gh4ce43m">{p.title}</h3>
              <p className="mt-2.5 text-[15px] leading-relaxed text-ink-mid" data-id="element-155" data-mp="17a37yhlq66hx">{p.body}</p>
            </article>)}
        </div>

        <div className="mt-16 rounded-2xl border border-hairline bg-panel p-8 lg:p-10" data-id="element-156" data-mp="137zuxojeqtuj">
          <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,320px)]" data-id="element-157" data-mp="1h3bohsltue9v">
            <div data-id="element-158" data-mp="1c2we99wudmw4">
              <div className="flex items-center gap-3" data-id="element-159" data-mp="1c4gya5lj5nfq">
                <ScaleIcon className="h-5 w-5 text-teal" aria-hidden="true" data-id="element-160" data-mp="odbj7sneyz6h" />
                <h3 className="font-mono text-2xl font-bold tracking-tight text-ink-hi" data-id="element-161" data-mp="kbqamjhwx723">
                  {licensing.headline}
                </h3>
              </div>
              <p className="mt-5 max-w-2xl leading-relaxed text-ink-mid" data-id="element-162" data-mp="y8db2w92qfcr">{licensing.body}</p>
            </div>

            <div className="space-y-4 lg:border-l lg:border-hairline lg:pl-10" data-id="element-163" data-mp="29pmq96l66l89">
              <div data-id="element-164" data-mp="29rppmh87pqpn">
                <p className="font-mono text-[11px] uppercase tracking-widest text-ink-mid" data-id="element-165" data-mp="24r1yzwnwbbvy">
                  Única excepción
                </p>
                <p className="mt-2 text-[15px] leading-relaxed text-ink-hi" data-id="element-166" data-mp="2cqy8iu64wu4f">{licensing.exception}</p>
              </div>
              <div className="rounded-lg border border-magenta-dim bg-panelalt p-4" data-id="element-167" data-mp="2gv5ysvs8qi4r">
                <p className="font-mono text-[11px] uppercase tracking-widest text-magenta" data-id="element-168" data-mp="2lsz4lnpmta4i">
                  Aclaración
                </p>
                <p className="mt-2 text-[14px] leading-relaxed text-ink-mid" data-id="element-169" data-mp="1t3s96xlh50nh">{licensing.note}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}